import React from 'react';

import { PersonalisationProgressBar } from '../PersonalisationProgressBar';
import { usePersonalisationContext } from '../../context/PersonalisationContext';

import styles from './personalisation-header.module.css';

/**
 * PersonalisationHeader component displays the header for the personalisation journey, including title, reset, and close actions.
 *
 * @param {Object} props - Component props
 * @param {string} props.title - The header title
 * @param {string} props.resetText - The reset button text
 * @param {function} props.onClose - Callback for closing the modal
 * @param {function} props.onReset - Callback for resetting the journey
 * @param {number} props.totalSteps - Total number of steps
 * @param {number} props.currentStep - Current step index
 * @param {boolean} props.isResetting - Whether the header is in resetting state
 * @returns {import('react').JSX.Element}
 */
export function PersonalisationHeader({ title, resetText, onClose, onReset, totalSteps, currentStep, isResetting }) {
  // PersonalisationHeader now directly uses context
  const { hasPersonalisationOptions } = usePersonalisationContext();

  return (
    <div className={styles['personalisation__header']}>
      <div className={styles['personalisation__header-content']}>
        {title && hasPersonalisationOptions && <h2 className="heading-2xl">{title}</h2>}
        <div className={styles['personalisation__header-actions']}>
          {resetText && hasPersonalisationOptions && (
            <button
              className={'body-sm button-reset ' + styles['personalisation__header-reset']}
              onClick={(e) => onReset(e)}
            >
              {resetText}
            </button>
          )}
          {onClose && (
            <button
              className={styles['personalisation__header-close'] + ' svg-wrapper button-reset'}
              onClick={(e) => onClose(e)}
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className={styles.icon} viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M5.35404 4.64645C5.15878 4.45118 4.8422 4.45118 4.64694 4.64645C4.45167 4.84171 4.45167 5.15829 4.64693 5.35355L11.2934 12L4.64693 18.6465C4.45167 18.8417 4.45167 19.1583 4.64694 19.3536C4.8422 19.5488 5.15878 19.5488 5.35404 19.3536L12.0005 12.7071L18.6469 19.3536C18.8422 19.5488 19.1588 19.5488 19.3541 19.3536C19.5493 19.1583 19.5493 18.8417 19.3541 18.6465L12.7076 12L19.3541 5.35355C19.5493 5.15829 19.5493 4.84171 19.3541 4.64645C19.1588 4.45118 18.8422 4.45118 18.6469 4.64645L12.0005 11.2929L5.35404 4.64645Z"
                  fill="#171717"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
      <PersonalisationProgressBar totalSteps={totalSteps} currentStep={currentStep} isResetting={isResetting} />
    </div>
  );
}
